import React, { useState } from "react";
import CustomTable from "../components/Table";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const Budgets = () => {
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");

  const data = [
    {
      id: 1,
      title: "Office Supplies",
      type: "Category",
      start: "14 Jan 2024",
      end: "14 Nov 2024",
      revenue: "250000",
      expense: "150000",
    },
  ];

  const filtered = data;

  const columns = [
    { title: "Budget Title", dataIndex: "title" },
    { title: "Type", dataIndex: "type" },
    { title: "Start Date", dataIndex: "start" },
    { title: "End Date", dataIndex: "end" },
    { title: "Revenue", dataIndex: "revenue" },
    { title: "Expense", dataIndex: "expense" },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <CustomTable
      title="Budgets"
      columns={columns}
      data={filtered}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onSearch={setSearch}
    />
  );
};

export default Budgets;